<template>
    <div class="level">
        <a class="button is-small tooltip has-background-info" data-tooltip="Automatic bid" style="margin-right: 5px;" @click="isAutomatic()">
            <span class="icon is-small">
                <i class="fas fa-sync-alt"></i>
            </span>
        </a>
        <a class="button is-small tooltip has-background-warning" data-tooltip="Real bid" @click="isReal()">
            <span class="icon is-small">
                <i class="fas fa-gavel"></i>
            </span>
        </a>
    </div>
</template>

<script>
    import apiBids from '../../api/apiBids'
    export default {
        props:['bid'],
        data() {
            return {
                isLoading: false,
                newBid: {
                    id: this.bid.id,
                    type: '',
                    group_name: this.bid.group.name,
                    group_id: this.bid.group.id
                }
            }
        },
        methods: {
            bidTypeUpdate() {
                apiBids
                    .updateBidRequest(this.newBid)
                    .then((response) => {

                    })
                    .catch((err) => {
                        console.log(err)
                    })
            },
            isAutomatic() {
                this.newBid.type = this.$bidIsAutomatic
                this.$emit('classChanged', 'is-automatic')
                this.bidTypeUpdate()
            },
            isReal() {
                this.newBid.type = this.$bidIsReal
                this.$emit('classChanged', 'is-real')
                this.bidTypeUpdate()
            }
        }
    }

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Bids/BidType.vue